import React from 'react';
import Logo from '../common/logo';
import illustrationImage from '../../assets/images/Illustration.png';

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 flex items-center justify-center px-4 sm:px-6 lg:p-0 overflow-y-auto">
      <div className="w-full lg:max-w-none max-w-md lg:flex lg:flex-1 lg:h-full my-6 lg:my-0">
        <div className="bg-white rounded-2xl lg:rounded-none shadow-2xl lg:shadow-none overflow-hidden flex-1 lg:flex">
          <div className="flex-1 lg:flex w-full">

            <div className="p-6 sm:p-8 lg:p-8 xl:p-10 flex flex-col justify-center lg:w-1/2">
              <div className="mb-4">
                <div className="flex items-center gap-3 mb-2">
                  <Logo size="default" />
                  <h1 className="text-2xl sm:text-3xl font-bold text-[#8B4513]">Pangolin Script</h1>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">AI-powered script generation for YouTube content creators</p>

                {title && (
                  <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 leading-tight">
                    {title}
                  </h2>
                )}

                {subtitle && (
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {subtitle}
                  </p>
                )}
              </div>

              <div className="fade-in">
                {children}
              </div>

              <div className="mt-4 lg:hidden text-center">
                <p className="text-xs text-gray-500">
                  © {new Date().getFullYear()} PangolinScript. All rights reserved.
                </p>
              </div>
            </div>

            <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-amber-700 via-amber-800 to-yellow-800 items-center justify-center relative overflow-hidden">

              <div className="absolute top-0 right-0 w-64 h-64 bg-amber-600/20 rounded-full -mr-32 -mt-32"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-yellow-600/20 rounded-full -ml-24 -mb-24"></div>

              <img
                src={illustrationImage}
                alt="Scriptwriting Illustration"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AuthLayout;